export default {
    ownerAccount: `创始帐号`,
    updateAccount: '账号设定',
    updateProfile: `更新账号`,
    locations: `仓库`,
    changePassword: `更换密码`,
    logout: `登出`
}